import { ezErrorDisplay, ezErrorDisplayOff } from 'ez-styles/assets/javascripts/ez-styles/utils/errors';
import { parseErrorMsg } from 'lib/validation-helpers';

export function socialSessionLoading(target, ogText = false) {
  const textTarget = target.querySelector('[data-target*="social-session-buttons.text"]') || null;

  if (ogText) {
    textTarget.innerHTML = ogText;
  } else {
    textTarget.innerHTML = target.dataset.loadingText;
  }
}

export function socialSessionError(value, target) {
  if (value) {
    ezErrorDisplay(target, parseErrorMsg(target, 'permissions_error'));
  } else {
    ezErrorDisplayOff(target);
  }
}

export function socialSessionRedirect(element, csrfToken, action) {
  const f = document.createElement('form');

  f.style.display = 'none';
  element.appendChild(f);

  const csrfField = document.createElement('input');

  csrfField.value = csrfToken;
  csrfField.name = 'authenticity_token';

  f.appendChild(csrfField);
  f.method = 'POST';
  f.action = action;
  f.submit();
}
